export default {
  contains: function contains(conditionResponses, diagResponses, returnNbResponseMatch) {
    var isFullfilled = false;
    var matches = [];
    Object.keys(diagResponses).map(function (qId) {
      return Object.keys(conditionResponses).map(function (key) {
        if (conditionResponses[key] && conditionResponses[key] === diagResponses[qId][key]) {
          isFullfilled = true;
          matches.push(key);
          return true;
        }
        return false;
      });
    });
    if (returnNbResponseMatch && isFullfilled) {
      return matches;
    }
    return isFullfilled;
  }
};